import styled from "styled-components";
import { SmallPrint } from "../typography/SmallPrint.styled";

const InputError = styled(SmallPrint)`
  color: ${(props) => props.theme.colors.alert};
`;

export default InputError;
